import React, { useEffect, useMemo, useRef, useState } from 'react';
import { Tooltip } from '@mui/material';
import ChipContent from '../TaskListResourcePlanner/ChipContent';
import MultiTooltipContent from './MultiTooltipContent';
import dayjs from 'dayjs';

const EventChip = ({ eventInfo, defaultStyles, allEvents }) => {
  const eventElementRef = useRef(null);
  const [hoveredDate, setHoveredDate] = useState(null);

  useEffect(() => {
    const eventElement = eventElementRef.current?.closest('.fc-h-event');
    if (eventElement) {
      if (eventInfo.isResizing || eventInfo.isDragging) {
        eventElement.style.backgroundColor = 'rgba(254, 215, 170, 0.6)';
      }
    }
  }, [eventInfo.isResizing, eventInfo.isDragging]);

  const handleMouseEnter = (e) => {
    const eventElement = e.currentTarget.closest('.fc-h-event');
    if (!eventElement) return;

    const start = dayjs(eventInfo.event.start);
    setHoveredDate(start);

    if (!eventInfo.isResizing && !eventInfo.isDragging && eventInfo.event?.extendedProps?.preparedness > 99) {
      eventElement.style.backgroundColor = '#55DD62';
    } else if (!eventInfo.isResizing && !eventInfo.isDragging && eventInfo.event?.extendedProps?.preparedness < 100) {
      eventElement.style.backgroundColor = '#fdba74';
    }
  };

  const handleMouseLeave = (e) => {
    const eventElement = e.currentTarget.closest('.fc-h-event');
    if (!eventInfo.isResizing && !eventInfo.isDragging && eventInfo.event?.extendedProps?.preparedness > 99) {
      eventElement.style.backgroundColor = defaultStyles.announced.backgroundColor;
    } else if (!eventInfo.isResizing && !eventInfo.isDragging && eventInfo.event?.extendedProps?.preparedness < 100) {
      eventElement.style.backgroundColor = defaultStyles.nonAnnounced.backgroundColor;
    }
    setHoveredDate(null);
  };

  const overlappingAtPoint = useMemo(() => {
    if (!hoveredDate) return [eventInfo.event];
    const resourceId =
      eventInfo.event.getResources?.()[0]?.id ?? eventInfo.event?.extendedProps?.eventData?.lineId ?? null;
    return (allEvents ?? [])
      .map((raw) => raw)
      .filter((ev) => {
        const evResource = ev.resourceId ?? ev.resourceIds?.[0] ?? ev.extendedProps?.eventData?.lineId ?? null;
        if (!resourceId || evResource != resourceId) return false;
        const s = dayjs(ev.start);
        const e = dayjs(ev.end ?? ev.start);
        return hoveredDate.isSame(s) || hoveredDate.isBetween(s, e, null, '[)');
      })
      .sort((a, b) => (a.id === eventInfo.event.id ? -1 : b.id === eventInfo.event.id ? 1 : 0));
  }, [hoveredDate, allEvents, eventInfo.event]);

  return (
    <Tooltip
      arrow
      placement="top"
      title={<MultiTooltipContent events={overlappingAtPoint} />}
      slotProps={{
        tooltip: {
          sx: {
            color: '#514E6A',
            backgroundColor: '#ffff',
            boxShadow: 'rgba(0, 0, 0, 0.35) 0px 5px 15px',
            minWidth: '200px',
          },
        },
        arrow: {
          sx: {
            color: '#ffff',
          },
        },
      }}
    >
      <div
        ref={eventElementRef}
        className="font-bold truncate  h-[20px]"
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
      >
        <ChipContent eventInfo={eventInfo} />
      </div>
    </Tooltip>
  );
};

export default EventChip;
